import Home from './pages/Home.vue'
import Collection from './pages/Collection.vue'
import History from './pages/History.vue'
import Auth from './pages/Auth.vue'
import About from './pages/About.vue'
import FourohFour from './pages/404.vue'

export default [{
		path: '/',
		component: Home,
		name: "Home"
	},
	{
		path: '/collection',
		component: Collection,
		name: "Collection"
	},
	{
		path: '/history',
		component: History,
		name: "History"
	},
	{
		path: '/about',
		component: About,
		name: "About"
	},
	{
		path: '/auth',
		component: Auth,
		name: "Auth"
	},
	{
		path: '*',
		component: Home,
		name: "Home"
	}
]


// WEBPACK FOOTER //
// ./src/routes.js